module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-angry.a6b9f5c9.png";